var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Badge } from 'antd';
import { RED } from 'ui/constants';
export var StyledBadge = styled(Badge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-badge-count {\n    background: ", ";\n    border: none;\n    transform: translate(66%, -66%);\n    box-shadow: none;\n  }\n"], ["\n  .ant-badge-count {\n    background: ", ";\n    border: none;\n    transform: translate(66%, -66%);\n    box-shadow: none;\n  }\n"])), RED);
export default StyledBadge;
var templateObject_1;
